import { ExternalLinkButton } from '@ui-common/components/ExternalLinkButton'
import { usePageTitle } from '@ui-common/hooks/usePageTitle'
import { LogoIconType } from '@ui-components/global/ComponentProps'
import { FixedButtonSection } from '@ui-components/global/LayoutStyling'
import { WizardStep } from '@ui-components/layout/WizardStep'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { MarketingSection } from '../../components/MarketingSection'
import { TheEndFooter } from '../../components/TheEndFooter'
import { useExistingLoanOfferContext } from '../LoanOfferContext'
import { TheEndTopBar } from '../the-end/TheEndTopBar'

const BookingLinkSection = styled(FixedButtonSection)`
  display: flex;
  flex-direction: column;
`
export const BookingStep = () => {
  const intl = useIntl()
  const formatMessage = intl.formatMessage
  const { loanOffer, goBack, goBackToStatus, exit } = useExistingLoanOfferContext()
  const title = formatMessage({ id: 'loan-offer-common-reservation-header' })
  const leadText = formatMessage({ id: 'loan-offer-common-reservation-lead-text' })
  usePageTitle(title)

  return (
    <>
      <TheEndTopBar onBackConfirmed={goBackToStatus} exit={exit} formatMessage={formatMessage} />
      <WizardStep
        isLoading={false}
        title={title}
        icon={LogoIconType.SPankki}
        shouldShowMainHeader={false}
        pageIntro={{
          title,
          leadText,
        }}
        subHeaderOptions={{
          previousButtonProps: {
            label: formatMessage({ id: 'common-back' }),
            onClick: goBack,
          },
        }}
        customFooter={<TheEndFooter />}
      >
        <MarketingSection />
        <BookingLinkSection>
          <ExternalLinkButton
            label={formatMessage({ id: 'loan-offer-common-reservation-booking-button-label' })}
            href={loanOffer.reservationLink}
          />
        </BookingLinkSection>
      </WizardStep>
    </>
  )
}
